import mutations from './eprofileEletmod.mutations'
import actions from './eprofileEletmod.actions'
import getters from './eprofileEletmod.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
